// extracted by mini-css-extract-plugin
export default {"note":"styles_note__X4Ujz","note__btn":"styles_note__btn__YtecV","note__text":"styles_note__text__Zj7sV","note__text_empty":"styles_note__text_empty__9ZjfM"};